/* ================================================================
   UGOPAWA COUTURE — AJAX Cart Drawer
   assets/ugopawa-cart.js
   ================================================================ */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 200 * 100; /* cents — adjust to match your store */

  var drawer       = document.getElementById('ugp-cart-drawer');
  var backdrop     = document.getElementById('ugp-cart-backdrop');
  var closeBtn     = document.getElementById('ugp-cart-close');
  var itemsEl      = document.getElementById('ugp-cart-items');
  var subtotalEl   = document.getElementById('ugp-cart-subtotal');
  var progressFill = document.getElementById('ugp-progress-fill');
  var shippingBar  = document.getElementById('ugp-shipping-bar');

  if (!drawer) return;

  /* Open / Close */
  function openDrawer() {
    drawer.classList.add('ugp-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('ugp-cart-backdrop--open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('ugp-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('ugp-cart-backdrop--open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ugp-cart-open]')) openDrawer();
  });

  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (backdrop)  backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Money formatter */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Shipping bar */
  function updateShippingBar(total) {
    if (!progressFill || !shippingBar) return;
    var pct       = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    var remaining = FREE_SHIPPING_THRESHOLD - total;
    progressFill.style.width = pct + '%';

    var msgEl = shippingBar.querySelector('.ugp-cart-drawer__shipping-msg');
    if (msgEl) {
      if (pct >= 100) {
        msgEl.className = 'ugp-cart-drawer__shipping-msg ugp-cart-drawer__shipping-msg--success';
        msgEl.innerHTML = '&#127881; You\'ve unlocked free shipping!';
      } else {
        msgEl.className = 'ugp-cart-drawer__shipping-msg';
        msgEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for free shipping';
      }
    }
  }

  /* Cart count badges */
  function updateCartCount(count) {
    document.querySelectorAll('.ugp-header__cart-badge, #ugp-cart-count').forEach(function (el) {
      if (el.id === 'ugp-cart-count') {
        el.textContent = '(' + count + ')';
      } else {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      }
    });
  }

  /* Render cart items */
  function renderItems(cart) {
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="ugp-cart-drawer__empty">' +
        '<p>Your bag is empty.</p>' +
        '<a href="/collections/all" class="ugp-btn ugp-btn--outline">Continue Shopping</a>' +
        '</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var imgHtml = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '&width=200" width="88" height="116" loading="lazy" class="ugp-cart-item__img" alt="' + (item.featured_image.alt || item.title) + '">'
        : '';
      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="ugp-cart-item__variant">' + item.variant_title + '</p>'
        : '';

      return '<div class="ugp-cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="ugp-cart-item__img-link" tabindex="-1">' + imgHtml + '</a>' +
        '<div class="ugp-cart-item__details">' +
        '<div class="ugp-cart-item__meta">' +
        '<p class="ugp-cart-item__vendor">' + (item.vendor || '') + '</p>' +
        '<a href="' + item.url + '" class="ugp-cart-item__title">' + item.product_title + '</a>' +
        variantHtml +
        '</div>' +
        '<div class="ugp-cart-item__row">' +
        '<div class="ugp-qty" role="group">' +
        '<button class="ugp-qty__btn" data-ugp-qty-change="-1" data-key="' + item.key + '" aria-label="Decrease">&#8722;</button>' +
        '<span class="ugp-qty__value" data-key="' + item.key + '">' + item.quantity + '</span>' +
        '<button class="ugp-qty__btn" data-ugp-qty-change="1" data-key="' + item.key + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<p class="ugp-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>' +
        '<button class="ugp-cart-item__remove" data-ugp-remove="' + item.key + '">Remove</button>' +
        '</div></div>';
    }).join('');
  }

  /* Refresh full cart */
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderItems(cart);
        updateShippingBar(cart.total_price);
        updateCartCount(cart.item_count);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        return cart;
      });
  }

  /* Change qty */
  function changeQty(key, delta) {
    var qtyEl   = itemsEl ? itemsEl.querySelector('.ugp-qty__value[data-key="' + key + '"]') : null;
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty  = Math.max(0, current + delta);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderItems(cart);
      updateShippingBar(cart.total_price);
      updateCartCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    });
  }

  /* Remove item */
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderItems(cart);
      updateShippingBar(cart.total_price);
      updateCartCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    });
  }

  /* Global add-to-cart */
  window.ugpAddToCart = function (variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} })
    })
    .then(function (r) { return r.json(); })
    .then(function () { return refreshCart(); })
    .then(function () { openDrawer(); });
  };

  /* Event delegation */
  document.addEventListener('click', function (e) {
    var qtyBtn    = e.target.closest('[data-ugp-qty-change]');
    var removeBtn = e.target.closest('[data-ugp-remove]');
    if (qtyBtn)    changeQty(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.ugpQtyChange, 10));
    if (removeBtn) removeItem(removeBtn.dataset.ugpRemove);
  });

})();
